// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e65b0f6d","488":"3d271d3f","667":"d41b63e9"}[chunkId] + ".chunk.js";
};